export function stringify(value) {
    if (!value)
        return null;
    return JSON.stringify(value);
}